import { useNavigate } from "react-router-dom"; // 1. Import hook

function NotFoundPage() {
  // 3. Initialize the hook
  const navigate = useNavigate();

  const goHome = () => {
    navigate("/");
  };

  return (
    <main className="main_container">
      <div
        style={{
          height: "calc(100svh - 150px)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 1000,
        }}
      >
        <div
          style={{
            textAlign: "center",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            gap: ".5rem",
          }}
        >
          <img
            src="https://s3.ap-southeast-3.amazonaws.com/mapid.jakarta.public/web_assets/mapid_error_graphic.png"
            alt="Not Found"
            width={"350rem"}
            style={{ marginBottom: "1rem" }}
          />

          <>
            <h1>Halaman tidak ditemukan</h1>
            <p style={{ width: "19rem", textAlign: "center", display: "flex" }}>
              Tidak ada
            </p>
          </>

          <button className="button background_red" onClick={goHome}>
            Kembali
          </button>
        </div>
      </div>
    </main>
  );
}

export default NotFoundPage;
